<template>
  <div class="study-task-quiz">
    <div class="desc" >
      {{ desc }}
    </div>
    <div class="btn">
      <button @click="clickAction">我要提问</button>
    </div>
  </div>
</template>

<script setup>
import { defineProps, getCurrentInstance } from 'vue'
import utils from '@utils/index'
import app from '@/widget/app'
import { hostPath } from '@utils/basePath'
const { proxy: { $router } } = getCurrentInstance()
const props = defineProps({
  desc: {
    type: String,
    default: ""
  },
  id: {
    type: Number,
    default: 0
  }
})

const clickAction = () => {
  if (utils.isApp()) {
    app.postMessage({
      type: 'h5',
      url: `${hostPath}/learn/exercise/question?taskId=${props.id}`
    })
  } else {
    $router.push({
      path: `/exercise/question`,
      query: {
        taskId: props.id
      }
    })
  }
}

</script>

<style lang="scss" scoped>
.study-task-quiz {
  .desc {
    color: #626366;
    font-size: 28px;
    line-height: 42px;
  }
  .btn {
    text-align: center;
    margin-top: 30px;
    button {
      display: inline-block;
      width: 176px;
      height: 72px;
      border-radius: 36px;
      border: none;
      color: #FF6600;
      font-size: 28px;
      background-color: #f5f5f5;
    }
  }
}
</style>
